import React from "react"
import { TrashIcon, HardHatIcon } from "./icons"

const HOUSEHOLD_LINKS = [
    { label: "10 yard dumpster prices", code: "10-yard-dumpster" },
    { label: "20 yard dumpster prices", code: "20-yard-dumpster" },
    { label: "30+ yard dumpster prices", code: "roll-off-dumpsters" },
]

const CONSTRUCTION_LINKS = [
    { label: "Construction dumpster prices", code: "construction-dumpster" },
]

const WASTE_TYPE_CONCRETE = '3'
const WASTE_TYPE_ROOFING = '4'

const ComparePricesLinks = ({ place, services = [] }) => {
    const isHubOrSub = /^Hub|^Sub/.test(place?.ht)
    if (!isHubOrSub) return null

    const placeSlug = place.name
        .replace(/ /g, "-")
        .replace(/,/g, "")
        .replace(/---/g, "-")
        .toLowerCase()

    const buildUrl = (code) => `/h/${placeSlug}/${code}`

    const handlePreselect = (wasteType) => {
        document.dispatchEvent(new CustomEvent('kpp:preselect-waste', { detail: { wasteType } }))
        document.getElementById('kpp-sidebar-search')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }

    return (
        <div className="compare-prices-links">
            <h2 className="compare-prices-links__title">
                Compare real-time prices for {place.name} dumpsters
            </h2>

            <div className="compare-prices-links__section compare-prices-links__section--household">
                <div className="compare-prices-links__section-header">
                    <TrashIcon />
                    <span>Household Trash</span>
                </div>
                <div className="compare-prices-links__grid">
                    {HOUSEHOLD_LINKS.map((link) => (
                        <a
                            key={link.code}
                            href={buildUrl(link.code)}
                            className="compare-prices-links__btn compare-prices-links__btn--blue"
                        >
                            {link.label}
                        </a>
                    ))}
                </div>
            </div>

            <div className="compare-prices-links__section compare-prices-links__section--construction">
                <div className="compare-prices-links__section-header">
                    <HardHatIcon />
                    <span>Construction and Demolition Debris</span>
                </div>
                <div className="compare-prices-links__grid">
                    {CONSTRUCTION_LINKS.map((link) => (
                        <a
                            key={link.code}
                            href={buildUrl(link.code)}
                            className="compare-prices-links__btn compare-prices-links__btn--orange"
                        >
                            {link.label}
                        </a>
                    ))}
                    <button
                        className="compare-prices-links__btn compare-prices-links__btn--orange"
                        onClick={() => handlePreselect(WASTE_TYPE_CONCRETE)}
                        type="button"
                    >
                        Concrete dumpster prices
                    </button>
                    <button
                        className="compare-prices-links__btn compare-prices-links__btn--orange"
                        onClick={() => handlePreselect(WASTE_TYPE_ROOFING)}
                        type="button"
                    >
                        Roofing dumpster prices
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ComparePricesLinks
